class ApiConstants {
  public static readonly LOCAL_ENDPOINT = 'http://localhost:8080';
  public static readonly DEV_ENDPOINT = 'https://partnerportal-dev.adobe.io';
  public static readonly PRESTAGE_ENDPOINT = 'https://partnerportal-prestage.adobe.io';
}

export default ApiConstants;
